import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6128265e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "false",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler")
  ])
], -1))
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse hide"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Tarih Aralığı", -1))
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " ", -1))
const _hoisted_12 = { class: "col-md-4 fv-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Müşteri", -1))
const _hoisted_14 = { class: "position-relative align-items-center" }
const _hoisted_15 = { class: "col-md-4 fv-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sezon", -1))
const _hoisted_17 = { class: "row g-12 mb-8" }
const _hoisted_18 = { class: "col-md-4 fv-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Üretici", -1))
const _hoisted_20 = { class: "position-relative align-items-center" }
const _hoisted_21 = { class: "col-md-4 fv-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Departman", -1))
const _hoisted_23 = { class: "position-relative align-items-center" }
const _hoisted_24 = { class: "col-md-4 fv-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sipariş Durumu", -1))
const _hoisted_26 = {
  key: 0,
  class: "p-dropdown-car-value"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "p-dropdown-car-option" }
const _hoisted_29 = { class: "row g-12 mb-8" }
const _hoisted_30 = { class: "col-md-4 fv-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Artikel Numarası", -1))
const _hoisted_32 = { class: "position-relative align-items-center" }
const _hoisted_33 = { class: "col-md-4 fv-row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Model Kodu", -1))
const _hoisted_35 = { class: "position-relative align-items-center" }
const _hoisted_36 = { class: "col-md-4 fv-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Order", -1))
const _hoisted_38 = { class: "row g-12 mb-8" }
const _hoisted_39 = { class: "col-md-4 fv-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "öko-Tex", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { class: "col-md-4 fv-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Numarası", -1))
const _hoisted_44 = { class: "row g-12 mb-8" }
const _hoisted_45 = { class: "col-md-4 fv-row" }
const _hoisted_46 = { class: "card-body py-3" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-12" }
const _hoisted_49 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_50 = { style: {"text-align":"left"} }
const _hoisted_51 = {
  key: 0,
  class: "image-text",
  width: "70"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#256029","width":"15px","height":"15px"} }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "image-text",
  width: "70"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#c63737","width":"15px","height":"15px"} }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "image-text" }
const _hoisted_58 = { class: "image-text" }
const _hoisted_59 = { class: "image-text" }
const _hoisted_60 = { class: "image-text" }
const _hoisted_61 = { class: "image-text" }
const _hoisted_62 = { class: "image-text" }
const _hoisted_63 = { class: "image-text" }
const _hoisted_64 = { class: "image-text" }
const _hoisted_65 = { class: "image-text" }
const _hoisted_66 = { class: "image-text" }
const _hoisted_67 = { class: "image-text" }
const _hoisted_68 = { class: "image-text" }

import { ref, computed, onMounted, defineComponent } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import { useRouter, useRoute } from "vue-router";
import Paginator from "primevue/paginator";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Department from "@/components/departments/Department.vue";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";

import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import Status from "./Status.vue";
import JwtService from "@/core/services/JwtService";
import Checkbox from "primevue/checkbox";
//JSON.parse(JwtService.getUser()).roles.find(x => x.id != 2)
import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  emits: ["changeSupplier"],
  setup(__props, { emit }) {

const router = useRouter();
const toast = useToast();
const store = useStore();

const loading = ref(false);
const statusModel = ref({ value: 0, name: "Tüm Siparişler" });
const totalCount = store.state.OrderModule.order.value[0]?.totalCount;
const onPage = (event) => {
  loading.value = true;
  var model = {
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    id: filters.value.id.constraints[0]?.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : null,
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : null,
    supplier: filters.value["supplier.name"].constraints[0]?.value,
    code: filters.value.code.constraints[0]?.value,
    model: filters.value.modelCode.constraints[0]?.value,
    departmentId: departmentId.value ? departmentId.value : 0,
    seasonId: seasonId.value ? seasonId.value : 0,
    modelCode: modelCode.value,
    orderCode: orderCode.value,
    articleNumber: articleNumber.value,
    page: event.page + 1,
    isActive: statusModel.value.value,
  };
  store.dispatch(Actions.ORDER_LIST, model).then((f) => {
    if (f.success) {
      loading.value = false;
    }
  });
};
const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};

const onRowSelect = (event) => {
  router.push({ name: "order-detail", params: { id: event.data.id } });
};

const remove = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_ACCOUNT, args.id)
        .then((x) => {
          store.dispatch(Actions.ACCOUNT_LIST).then((f) => {
            toast.add({
              severity: "success",
              summary: "İşlem Sonucu",
              detail: x.message,
              life: 3000,
            });
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};

const orders = computed(() => store.state.OrderModule.order.value);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  id: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderQuantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
  deliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  date: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNumber: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  department: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  code: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  "supplier.name": {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  modelCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  oekoTex: { value: null, matchMode: FilterMatchMode.EQUALS },
});

const exportExcel = () => {
  import("xlsx").then((xlsx) => {
    const data = filteredData.value.map((x) => {
      return {
        Durum: x.isActive == 1 ? "Açık" : "Kapalı",
        "Sipariş Numarası": x.id,
        Tarih: x.date,
        Müşteri: x.customer.name,
        Artikel: x.articleNumber,
        Departman: x.department.name,
        Order: x.code,
        Üretici: x.supplier.name,
        "Model Kodu": x.modelCode,
        Sezon: x.season.name,
        "Yükleme Tarihi": x.estimatedShippingDate,
        "Varış Tarihi": x.estimatedDeliveryDate,
        Açıklama: x.explain,
      };
    });

    const ws = xlsx.utils.json_to_sheet(data);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "sheet01");

    const fileName = `order_list_${moment(new Date()).format()}.xlsx`;

    xlsx.writeFile(wb, fileName);
  });
};

const selectedStatus = (args) => {
  statusModel.value = { value: args.value.value, name: args.value.name };
  // if (args != null) {
  //   console.log(args.value);
  //   statusModel.value = {value:args.value.value,name:args.value.name};
  // }
  // {
  //   alert(33);
  //   statusModel.value = { value: 0, name: "Tüm Siparişler" };
  // }
};
const orderStatus = ref([
  { id: 0, name: "Tüm Siparişler" },
  { id: 1, name: "Açık" },
  { id: 2, name: "Kapalı" },
]);

const customers = ref();
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const departmentId = ref();
const selectedDepartment = (args) => {
  if (args.value == null) {
    departmentId.value = null;
  } else {
    departmentId.value = args.value.value;
  }
};
const suppliers = ref();
const suppliers2 = ref();
const selectedSupplier = (args) => {
  if (args.value == null) {
    suppliers.value = null;
  } else {
    suppliers.value = args.value;
  }
};
const seasonId = ref();
const selectedSeason = (args) => {
  if (args.value) {
    seasonId.value = args.value.value;
  } else {
    seasonId.value = null;
  }
};
const statusList = computed(() => orderStatus.value || []);
const orderDate = ref();
const orderDateOne = ref();
const orderDateTwo = ref();
const customerIds = ref();
const modelCode = ref();
const articleNumber = ref();
if (
  window.localStorage.getItem("articleNumber") != null ||
  window.localStorage.getItem("articleNumber") != undefined
) {
  articleNumber.value = window.localStorage.getItem("articleNumber");
}
const orderCode = ref();
const orderId = ref();
const send = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    id: orderId?.value,
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : null,
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : null,
    departmentId: departmentId.value ? departmentId.value : 0,
    seasonId: seasonId.value ? seasonId.value : 0,
    modelCode: modelCode.value,
    orderCode: orderCode.value,
    articleNumber: articleNumber.value,
    page: 1,
    isActive: statusModel.value.value,
    oekoTex: oekoTex.value,
  };
  if (articleNumber.value) {
    window.localStorage.setItem("articleNumber", articleNumber.value);
  }
  store.dispatch(Actions.ORDER_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};

const orderCopy = (args) => {
  var auth = JSON.parse(JwtService.getUser());
  if (JSON.parse(JwtService.getUser()).roles.find((x) => x.id == 3)) {
    error("Yetkiniz yok.");
  } else {
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
    store.dispatch(Actions.ORDER_COPY, args).then((f) => {
      if (f.success) {
        window.location.reload();
      } else {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      }
    });
  }
};
store.dispatch(Actions.SUPPLIER_LIST);
const orderDelete = (args) => {
  var auth = JSON.parse(JwtService.getUser());
  if (JSON.parse(JwtService.getUser()).roles.find((x) => x.id == 3)) {
    error("Yetkiniz yok.");
  } else {
    Swal.fire({
      title: "İlgili kayıt silinsin mi?",
      text: "Emin misiniz? Bu işlemi geri alamazsınız!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Evet, Sil!",
      cancelButtonText: "İptal",
    }).then((result) => {
      // <--
      if (result.value) {
        Swal.fire({
          title: "Silmek için açıklama girin",
          input: "textarea",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "İptal",
          showLoaderOnConfirm: true,
          preConfirm: (explain) => {
            var model = {
              id: args,
              explain: explain,
            };
            store.dispatch(Actions.ORDER_DELETE, model).then((f) => {
              if (f.success) {
                store.dispatch(Actions.ORDER_LIST, { page: 1 }).then(() => {
                  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                  success(f.message);
                });
              } else {
                store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
                error(f.message);
              }
            });
          },
        });
      }
    });
  }
};
const success = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const error = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const oekotexList = ref([
  { name: "Evet", value: true },
  { name: "Hayır", value: false },
]);
const oekoTex = ref(false);
const testAli = ref(false);
const clear = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  articleNumber.value = null;
  modelCode.value = null;
  orderCode.value = null;
  orderId.value = null;
  orderDateOne.value = null;
  orderDateTwo.value = null;
  oekoTex.value = false;

  window.localStorage.removeItem("articleNumber");
  //window.location.reload();

  store.dispatch(Actions.ORDER_LIST, { page: 1 }).then((f) => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const clearFilter1 = () => {
  initFilters1();
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    id: orderId?.value,
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : null,
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : null,
    departmentId: departmentId.value ? departmentId.value : 0,
    seasonId: seasonId.value ? seasonId.value : 0,
    modelCode: modelCode.value,
    orderCode: orderCode.value,
    articleNumber: articleNumber.value,
    page: 1,
    isActive: statusModel.value.value,
    oekoTex: oekoTex.value,
  };

  store.dispatch(Actions.ORDER_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};

const initFilters1 = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderQuantity: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    deliveryDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    date: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    shippingDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    articleNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    department: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    seasonName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    code: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    "supplier.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modelCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    oekoTex: { value: null, matchMode: FilterMatchMode.EQUALS },
  };
};
const onFilter = (args) => {
  if (filters.value.id.constraints[0].value) {
    getOrderFilter();
  } else if (filters.value["supplier.name"].constraints[0].value) {
    getOrderFilter();
  } else if (filters.value.modelCode.constraints[0].value) {
    getOrderFilter();
  } else if (filters.value.code.constraints[0].value) {
    getOrderFilter();
  } else if (filters.value.oekoTex.value) {
    getOrderFilter();
  }
};

const getOrderFilter = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    id: filters.value.id.constraints[0]?.value,
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : null,
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : null,
    supplier: filters.value["supplier.name"].constraints[0]?.value,
    code: filters.value.code.constraints[0]?.value,
    departmentId: departmentId.value ? departmentId.value : 0,
    seasonId: seasonId.value ? seasonId.value : 0,
    modelCode: modelCode.value,
    model: filters.value.modelCode.constraints[0]?.value,
    orderCode: orderCode.value,
    articleNumber: articleNumber.value,
    page: 1,
    isActive: statusModel.value.value,
    oekoTex: oekoTex.value,
  };

  store.dispatch(Actions.ORDER_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};

const goToTechnicalTracking = (id) => {
  router.push(`/order/technical-tracking/${id}`);
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(Season, {
                class: "col-md-12",
                onChangeSeason: selectedSeason
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(SupplierMultiSelect, {
                  class: "col-md-12",
                  data: null,
                  onChangeSupplier: selectedSupplier
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Department, {
                  class: "col-md-12",
                  onChangeDepartment: selectedDepartment
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_Dropdown, {
                modelValue: statusModel.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((statusModel).value = $event)),
                options: 
                _unref(statusList).map((o) => {
                  return { name: o.name, value: o.id };
                })
              ,
                optionLabel: "name",
                filter: true,
                placeholder: "Seçiniz",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (selectedStatus($event))),
                style: {"width":"100%"}
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: articleNumber.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((articleNumber).value = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: modelCode.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modelCode).value = $event)),
                  class: "col-md-12"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: orderCode.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((orderCode).value = $event)),
                class: "col-md-12"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createTextVNode(),
              _hoisted_41,
              _createVNode(_unref(Checkbox), {
                id: "binary",
                modelValue: oekoTex.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((oekoTex).value = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: orderId.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((orderId).value = $event)),
                class: "col-md-12"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("button", {
                id: "performance-report_submit",
                ref: "submitButtonSettings",
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (send()))
              }, " Görüntüle ", 512),
              _createElementVNode("button", {
                id: "performance-report_submit",
                ref: "submitButtonSettings",
                class: "btn btn-primary",
                style: {"margin-left":"5px"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => (clear()))
              }, " Temizle ", 512)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          (_unref(store).state.OrderModule.order.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49))
            : _createCommentVNode("", true),
          _createVNode(_component_DataTable, {
            sortOrder: -1,
            showGridlines: "",
            value: _unref(store).state.OrderModule.order.value,
            globalFilterFields: [
            'name',
            'country.name',
            'representative.name',
            'status',
          ],
            class: "p-datatable-sm",
            responsiveLayout: "scroll",
            stripedRows: "",
            onValueChange: filterData,
            loading: loading.value,
            filters: filters.value,
            "onUpdate:filters": _cache[13] || (_cache[13] = ($event: any) => ((filters).value = $event)),
            dataKey: "id",
            rows: 50,
            onRowSelect: onRowSelect,
            selectionMode: "single",
            filterDisplay: "menu",
            onFilter: _cache[14] || (_cache[14] = ($event: any) => (onFilter($event))),
            style: {"width":"max-content","min-width":"-webkit-fill-available","font-size":"11px","font-weight":"bold","max-width":"90% !important"}
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_Button, {
                  icon: "pi pi-file-excel",
                  class: "p-button-rounded btn btn-primary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (exportExcel($event))),
                  style: {"padding":"0"}
                }),
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-filter-slash",
                  label: "Temizle",
                  class: "p-button-outlined",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (clearFilter1())),
                  style: {"margin-left":"10px"}
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, null, {
                body: _withCtx(({ data }) => [
                  (data.isActive == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _hoisted_53))
                    : (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: "Sipariş",
                sortable: true,
                filterMatchMode: "contains",
                style: {"min-width":"6rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_57, _toDisplayString(data.id), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Sipariş Ara.."
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "date",
                header: "Tarih",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"2rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_58, _toDisplayString(data.date), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "customer.name",
                header: "Müşteri",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"4rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(data.customer.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "department.name",
                header: "Departman",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"8rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_60, _toDisplayString(data.department.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "brand.name",
                header: "Marka",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"8rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_61, _toDisplayString(data.brand?.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "shippingType.name",
                header: "Yükleme Şekli",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"8rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(data.shippingType?.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "orderType.name",
                header: "Sipariş Şekli",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"8rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_63, _toDisplayString(data.orderType?.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "supplier.name",
                header: "Üretici",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"4rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_64, _toDisplayString(data.supplier.name), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Üretici İçinde Ara"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "modelCode",
                header: "Model Kodu",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"6rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(data.modelCode), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Model Kodu İçinde Ara"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "articleNumber",
                header: "Artikel",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"3rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_66, _toDisplayString(data.articleNumber), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "code",
                header: "Order",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"5rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_67, _toDisplayString(data.code), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Order içinde ara"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "oekoTex",
                header: "öko-Tex",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"2rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_68, [
                    _createVNode(_unref(Checkbox), {
                      id: "binary",
                      modelValue: data.oekoTex,
                      "onUpdate:modelValue": ($event: any) => ((data.oekoTex) = $event),
                      binary: true,
                      disabled: true,
                      style: {"zoom":"0.8"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_Dropdown, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    options: [
                  { label: 'Yok', value: false },
                  { label: 'Var', value: true },
                ],
                    optionLabel: "label",
                    optionValue: "value",
                    class: "p-column-filter",
                    placeholder: "Seçiniz",
                    showClear: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "season.name",
                header: "Sezon",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"6rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.season.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "estimatedShippingDate",
                header: "Yükleme Tarihi",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"4rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.estimatedShippingDate), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "estimatedDeliveryDate",
                header: "Varış Tarihi",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"4rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.estimatedDeliveryDate), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "explain",
                header: "Açıklama",
                sortable: true,
                filterMatchMode: "contains",
                style: {"min-width":"3rem","font-weight":"bold"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.explain), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                exportable: false,
                style: {"min-width":"12rem","white-space":"nowrap"}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-copy",
                    class: "copy btn btn-icon p-button-secondary btn-active-color-primary btn-sm me-1",
                    style: {"background-color":"#ec8b2f"},
                    onClick: ($event: any) => (orderCopy(slotProps.data.id)),
                    "data-bs-toggle": "tooltip",
                    title: "Kopyala"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-cog",
                    class: "btn btn-icon p-button-info btn-active-color-primary btn-sm me-1",
                    onClick: ($event: any) => (goToTechnicalTracking(slotProps.data.id)),
                    "data-bs-toggle": "tooltip",
                    title: "Teknik Takip"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "btn btn-icon p-button-danger btn-active-color-primary btn-sm",
                    onClick: ($event: any) => (orderDelete(slotProps.data.id)),
                    "data-bs-toggle": "tooltip",
                    title: "Sil"
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "globalFilterFields", "loading", "filters"]),
          (_unref(store).state.OrderModule.order.value)
            ? (_openBlock(), _createBlock(_unref(Paginator), {
                key: 1,
                rows: 50,
                totalRecords: _unref(store).state.OrderModule.order.value[0]?.totalCount,
                onPage: _cache[15] || (_cache[15] = ($event: any) => (onPage($event)))
              }, null, 8, ["totalRecords"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})